export const BUNDLE = 'bundle';
export const PROMO = 'promo';
export const LANDING = 'landing';
export const IFRAME = 'iframe';
export const OVERVIEW = 'overview';
